import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: 'switcher',
	template: `
		<div class="btn-group btn-group-toggle" data-toggle="buttons">
			<button
				type="button"
				class="btn btn-default"
				*ngFor="let option of options; let i = index"
				[ngClass]="[
					i === activeOptionIndex ? 'active' : ''
				]"
				(click)="toggleActive(i)"
			>
				{{ option }}
			</button>
		</div>
	`,
	styles: [
		`.btn-group .btn.active {
			color: #fff;
			background-color: #545b62;
			border-color: #4e555b;
		}`,
	],
})
export class SwitcherComponent {
	@Input() options = [];
	@Input() activeOptionIndex = 0;
	
	@Output() public onChange: EventEmitter<string> = new EventEmitter<string>();
	
	constructor() {
		
	}
	
	toggleActive(i: number) {
		this.activeOptionIndex = i;
		
		this.onChange.emit(this.options[i]);
	}
}
